import { send } from '@/api/invitation';
import { handleError } from '@/actions/common';
import { User } from '@bimdata/definitions/dto';
import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { AccessLevel } from '@bimdata/definitions/const';

export default async (code: string, access: AccessLevel, user: User | string) => {
  try {
    const invitation = await send(code, {
      ...((typeof user === 'string') ? { email: user } : { user: user.id }),
      access
    });

    store.dispatch(
      projectSlice.actions.addInvitation({
        code,
        invitation: {
          id: invitation.id,
          access: invitation.project.access,
          participant: invitation.participant
        },
      })
    );
  } catch (error) {
    handleError(error);
    // throw error;
  }
};